import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import moment from "moment";

import afterLoginApiAxios from "../../Util/API Calls/afterLogin";
import { LOCALSTORAGEKEY } from "../../Util/Helper/localStorageUtils";
import { C2CConsole } from "../../Util/Helper/C2CConsole";

export default function UpcomingVacationWidget(props) {
  const { handleUpcomingVacation } = props;
  const [upcomingVacation, setUpcomingVacation] = useState({
    id: "",
    start_date: "",
    end_date: "",
  });

  const userId = localStorage.getItem(LOCALSTORAGEKEY.USER_ID);

  useEffect(() => {
    afterLoginApiAxios
      .post(
        "/doctor/get-vacation",
        { doctor_id: userId },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: localStorage.getItem("id_token"),
          },
        }
      )
      .then((response) => {
        if (response.data) {
          if (response.data.statusCode == 200) {
            if (response.data.data) {
              setUpcomingVacation(response.data.data[0]);
              if (response.data.data[0].id) {
                handleUpcomingVacation(true);
              }
            }
          } else {
            // TODO: Error handling and logging
          }
        } else {
          // TODO: Error handling and logging
        }
      })
      .catch((err) => C2CConsole.log(err));
  }, []);

  return upcomingVacation.id !== "" ? (
    <div className="col-lg-6 col-10 mt-lg-0 mt-3 p-0 plr_15_fit_content">
      <div className="card upcoming-vacation mb-0">
        <div className="card-body p-1">
          <div className="row position-relative">
            <div className="col-6 d-flex flex-row justify-content-center align-items-center border-right pl-4 position-static">
              <img
                src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAZCAYAAAA4/K6pAAAAAXNSR0IArs4c6QAAADhlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAAqACAAQAAAABAAAAEKADAAQAAAABAAAAGQAAAAAajTG5AAABaElEQVQ4Ee1VS1LCQBDtF2PAXW4ANzBHCDdwayGl2VGu9ATCCXSl2QllWS6NJxBPoDfQI2RHVYC03QkJk6iFlC6ZRea915+a6UnPgL4Zyem9x5xeiMnPzIzIoZ0hwsOPjBsfGDiDy+BnIrhM/AIml4B9Io4Bq+Ncd9/MGMskilPmSIPBCJo3Pb8R9jxiHqqWpnxZ9/8zR7FfZribZAM4dqbzwNYlg9DCl2qsSwdKmruwJK61zvUnO4PdShG1cMT0VAZkxaNxyUlwrpVSJYETdkdyXOUxyQkMLGbR8qFYtYLrXElgGn6Ltwm2Rfz/H4lPbl1prrKtuf/QTrHiilUz/1LbJMme/a43T6ElmL+aXPCjaLHMhUu9F1bBuUedq1rVLCY6L9NtCGQdV9ladF8JFgOJP9Yc0rYdnc2xADxxLi7VsTOdnWEUxFkCdZz17/yUEAmcNMKjAzNYsRY4adoT2UJb3giveCM+AaD5ewsN4DFDAAAAAElFTkSuQmCC"
                alt="vacation"
              />
              <Link
                to={{ pathname: "/doctor/account/myschedulefees2" }} //adding new my schedule route
                className="pl-2 stretched-link"
              >
                Upcoming Vacation
              </Link>
            </div>
            <div className="col-6 d-flex flex-column justify-content-start dates position-static">
              <span>
                {upcomingVacation?.start_date !== upcomingVacation?.end_date
                  ? moment(upcomingVacation.start_date).format("DD MMM") +
                    " to "
                  : moment(upcomingVacation.start_date).format("DD MMM, YYYY")}
              </span>
              {upcomingVacation?.start_date !== upcomingVacation?.end_date && (
                <span>
                  {moment(upcomingVacation.end_date).format("DD MMM, YYYY")}
                </span>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  ) : (
    ""
  );
}
